import { Button } from '@components/button';
import { CopyText } from '@components/copy-text-field';
import { Separator } from '@components/separator';
import { Stack } from '@components/stack';
import { Text } from '@components/text';

import { Modal } from 'features/modals';
import { useStore } from 'models/Provider';

type Props = {
  closeModal: () => void;
  clientId: string;
  clientSecret: string;
};

export const UserAppCredentialsModal = (props: Props) => {
  const { t } = useStore();
  const { closeModal } = props;

  return (
    <Modal>
      <Modal.Header text={t('modals.userappcredentials.header')} />
      <Stack space={4}>
        <Text text={t('modals.userappcredentials.helptext')} />
        <Separator />
        <Stack space={4}>
          <CopyText
            copyText={t('copy.button.text')}
            copiedText={t('copy.button.copied')}
            label={t('modals.userappcredentials.clientid.label')}
            value={props.clientId}
          />
          <CopyText
            copyText={t('copy.button.text')}
            copiedText={t('copy.button.copied')}
            label={t('modals.userappcredentials.clientsecret.label')}
            value={props.clientSecret}
            helpText={t('modals.userappcredentials.secret.helptext')}
          />
        </Stack>
      </Stack>
      <Modal.Actions>
        <Button
          variant="secondary"
          onClick={closeModal}
          text={t('modals.userappcredentials.close')}
        />
      </Modal.Actions>
    </Modal>
  );
};
